import React, { forwardRef } from 'react';

import type { IconButtonProps } from '@mui/material';
import { IconButton } from '@mui/material';
import clsx from 'clsx';
import { CloseIcon } from 'src/components/icons/CloseIcon';
import { RedoIcon } from 'src/components/icons/RedoIcon';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  button: {
    padding: theme.spacing(1),
  },
  icon: {
    height: 12,
    width: 12,
  },
  iconRestore: {
    height: 14,
    width: 14,
  },
}));

interface SmallCloseIconButtonProps extends Omit<IconButtonProps, 'size'> {
  variant?: 'close' | 'restore';
}

export const SmallCloseIconButton = forwardRef(function SmallCloseIconButton(
  props: SmallCloseIconButtonProps,
  ref: React.Ref<HTMLButtonElement>
): JSX.Element {
  const { className, variant = 'close', ...rest } = props;
  const { classes } = useStyles();
  const Icon = variant === 'restore' ? RedoIcon : CloseIcon;

  const iconClassName = variant === 'restore' ? classes.iconRestore : classes.icon;

  return (
    <IconButton ref={ref} className={clsx(className, classes.button)} size="small" {...rest}>
      <Icon className={iconClassName} />
    </IconButton>
  );
});
